import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectService } from '../../Services/project.service';
import swal from 'sweetalert2';

export interface TeamReductionDialogData {
  // Pass any required data if needed
}

export interface TeamReductionDialogResult {
  success: boolean;
}

@Component({
  selector: 'app-team-reduction-dialog',
  templateUrl: './team-reduction-dialog.component.html',
  styleUrls: ['./team-reduction-dialog.component.css'],
  standalone: false
})
export class TeamReductionDialogComponent implements OnInit {

  teams: any[] = [];
  users: any[] = [];
  loading = true;
  deleting = false;

  selectedTeamToDelete: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<TeamReductionDialogComponent, TeamReductionDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: TeamReductionDialogData,
    private projectService: ProjectService
  ) { }

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData(): void {
    this.loading = true;
    
    // Fetch users first to map employee IDs to names
    this.projectService.getUserList(0, 0).subscribe({
      next: (users: any) => {
        this.users = users;
        this.fetchTeams();
      },
      error: () => {
        this.loading = false;
        swal.fire('Error', 'Failed to load users', 'error');
      }
    });
  }

  fetchTeams(): void {
    this.projectService.getTeamList().subscribe({
      next: (teams: any) => {
        this.teams = teams || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        swal.fire('Error', 'Failed to load teams', 'error');
      }
    });
  }

  onSelectTeamToDelete(teamId: string): void {
    this.selectedTeamToDelete = teamId;
  }

  onDeleteTeam(): void {
    if (!this.selectedTeamToDelete) return;
    
    const team = this.teams.find(t => t.id === this.selectedTeamToDelete);
    if (!team) return;

    this.deleting = true;
    this.projectService.deleteTeam(this.selectedTeamToDelete).subscribe({
      next: () => {
        this.deleting = false;
        // Also refresh the overall list since a team was deleted
        this.projectService.refreshCurrentUser().subscribe();
        swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Team Deleted',
          showConfirmButton: false,
          timer: 3000
        });
        this.selectedTeamToDelete = null;
        this.fetchData(); // reload teams
      },
      error: (err) => {
        this.deleting = false;
        swal.fire('Error', err?.error?.message || 'Failed to delete team', 'error');
      }
    });
  }

  getMemberCount(team: any): number {
    if (!team || !team.meta) return 0;
    const managers = this.parseMetaIds(team.meta.team_manager);
    const leads = this.parseMetaIds(team.meta.team_lead);
    const developers = this.parseMetaIds(team.meta.team_developer);
    const allIds = new Set([...managers, ...leads, ...developers]);
    return allIds.size;
  }

  parseMetaIds(metaString: string): string[] {
    if (!metaString) return [];
    return metaString.replace(/~/g, ',').split(',').filter(id => id.trim() !== '');
  }

  onCancel(): void {
    this.dialogRef.close({ success: true });
  }
}
